import React from 'react';
import {
  ConnectedToolsSection,
  SectionHeading,
  ConnectedTools,
  ConnectedToolLink,
  ConnectedToolIcon,
} from './ConnectedSafetyTools.styles';
import { FaClipboardCheck, FaBookOpen } from 'react-icons/fa';

const ConnectedSafetyTools = () => {
  return (
    <ConnectedToolsSection>
      <SectionHeading>
        <p className="eyebrowHeader">Beyond Training</p>

        <h2>Keep More of Your Safety Program Connected</h2>

        <p>
          Company training is only one part of workplace safety management. Yoda
          Safety Services also provides digital tools for forms and safety
          manuals.
        </p>
      </SectionHeading>

      <ConnectedTools>
        <ConnectedToolLink to="/digital-safety-forms">
          <ConnectedToolIcon>
            <FaClipboardCheck />
          </ConnectedToolIcon>

          <div>
            <span>Digital Safety Forms</span>

            <h3>Move Workplace Forms Online</h3>

            <p>
              Give employees access to digital safety forms that can be
              completed, saved, and managed online.
            </p>

            <strong>
              Explore Digital Forms
              <span aria-hidden="true">→</span>
            </strong>
          </div>
        </ConnectedToolLink>

        <ConnectedToolLink to="/safety-manuals">
          <ConnectedToolIcon>
            <FaBookOpen />
          </ConnectedToolIcon>

          <div>
            <span>Safety Manuals</span>

            <h3>Make Important Information Easier to Access</h3>

            <p>
              Keep workplace safety manuals and documentation available to the
              people who need them.
            </p>

            <strong>
              Explore Safety Manuals
              <span aria-hidden="true">→</span>
            </strong>
          </div>
        </ConnectedToolLink>
      </ConnectedTools>
    </ConnectedToolsSection>
  );
};

export default ConnectedSafetyTools;
